import React from 'react';
import Search from './components/Search';
import CreateBtn from './components/CreateBtn';
import UnassignedGamesCheckBox from './components/UnassignedGamesCheckBox';
import ResetBtn from './components/ResetBtn';
import SortBy from './components/SortBy/SortBy';
import CountOfItem from './components/CountOfItem';
import WithURLFilters from './components/WithURLFilters';
import CategorySelect from './components/CategorySelect';
import DeveloperSelect from './components/DeveloperSelect';
import AssignmentBtn from './components/AssignmentBtn';
import GamesCategoriesBtn from './components/GamesCategoriesBtn';
import ChangePositionBtn from './components/ChangePositionBtn';
import DevelopersBtn from './components/DevelopersBtn';
import style from './GamesControlPanel.module.scss';

const GamesControlPanel: React.FC = () => {
	return (
		<WithURLFilters>
			<div className={style.firstRowWithControls}>
				<CreateBtn />
				<AssignmentBtn />
				<GamesCategoriesBtn />
				<ChangePositionBtn />
				<DevelopersBtn />
			</div>
			<div className={style.secondRowWithControls}>
				<div className={style.selectWrapper}>
					<div className={style.searchWrapper}>
						<Search />
					</div>
					<CategorySelect />
					<DeveloperSelect />
					<UnassignedGamesCheckBox />
				</div>
			</div>
			<div className={style.verticalAlignBlock}>
				<ResetBtn />
				<SortBy />
				<CountOfItem />
			</div>
		</WithURLFilters>
	);
};

export default GamesControlPanel;
